import React from 'react';
export function ValueStack() {
  const items = [{
    name: '📗 Tomo I — La Base del Control',
    value: '$19,999'
  }, {
    name: '📘 Tomo II — La Mente del Campeón',
    value: '$19,999'
  }, {
    name: '🎧 Bono #1 — Meditaciones del Guerrero',
    value: '$9,500'
  }, {
    name: '📋 Bono #2 — Plan de 30 Días',
    value: '$7,000'
  }, {
    name: '⚡ Bono #3 — Guía de Emergencia',
    value: '$15,000'
  }];
  return <section className="bg-gradient-to-b from-[#0a0a0a] via-[#100800] to-[#0a0a0a] py-[36px] px-5 text-center" data-id="element-198">
      <div className="max-w-[860px] mx-auto px-5" data-id="element-199">
        <h2 className="font-montserrat font-black text-[clamp(1.5rem,4vw,2.4rem)] text-brand-white uppercase mb-2 leading-[1.15]" data-id="element-200">
          El Valor Real de
          <br data-id="element-201" />
          <span className="text-brand-red" data-id="element-202">Todo lo que Recibes</span>
        </h2>
        <div className="w-[60px] h-[3px] bg-brand-red mx-auto mt-[10px] mb-[22px] rounded-[2px]" data-id="element-203"></div>

        <table className="w-full border-collapse my-[16px] text-left" data-id="element-204">
          <tbody data-id="element-205">
            {items.map((item, idx) => <tr key={idx} className="border-b border-[#1a1a1a] transition-colors duration-200 hover:bg-[#111]" data-id="element-206">
                <td className="py-[14px] px-2 text-[0.95rem] text-brand-gray-text" data-id="element-207">
                  {item.name}
                </td>
                <td className="py-[14px] px-2 text-[0.95rem] text-right font-montserrat font-bold text-brand-gold whitespace-nowrap" data-id="element-208">
                  {item.value}
                </td>
              </tr>)}
            <tr className="bg-gradient-to-br from-[#150000] to-[#100000]" data-id="element-209">
              <td className="py-[18px] px-2 text-[1.1rem] font-montserrat font-black text-brand-white uppercase tracking-[1px]" data-id="element-210">
                💰 Valor Total del Sistema Completo
              </td>
              <td className="py-[18px] px-2 text-[1.4rem] text-right font-montserrat font-bold text-brand-red whitespace-nowrap" data-id="element-211">
                $71,500
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>;
}